module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-24.57d32e86.png";